export default {
    videos: 5,
    images: 10,
    liveCameras: 5
}